import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ScrollText, CheckCircle2, Download } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Covenant() {
  const { user, setUser } = useAuth();
  const [state, setState] = useState({ signed: false, signature: "", signed_at: null });
  const [sig, setSig] = useState("");
  const [text, setText] = useState("");

  useEffect(() => {
    Promise.all([api.get("/covenant"), api.get("/curriculum/intro")]).then(([c, i]) => {
      setState(c.data);
      setSig(c.data.signature || user?.name || "");
      setText(i.data.covenant_text);
    });
  }, [user]);

  const sign = async () => {
    if (!sig.trim()) return toast.error("Write your name to sign.");
    await api.post("/covenant", { signature: sig });
    toast.success("The covenant is signed.");
    setState({ signed: true, signature: sig, signed_at: new Date().toISOString() });
    setUser({ ...user, covenant_signed: true });
  };

  return (
    <div className="max-w-3xl mx-auto">
      <div className="flex items-center gap-3 text-primary">
        <ScrollText className="w-5 h-5" />
        <p className="text-xs uppercase tracking-[0.2em]">Answering the Call · The Covenant</p>
      </div>
      <h1 className="font-serif text-5xl mt-4 leading-tight">
        Not a graduation. <br /><em>A beginning.</em>
      </h1>

      <section className="mt-12 border border-border bg-card p-10 lg:p-14 shadow-[0_8px_30px_rgba(42,42,38,0.06)]">
        <p className="font-serif text-xl leading-[1.8] italic whitespace-pre-wrap">{text}</p>

        <div className="rule-line my-10"></div>

        {state.signed ? (
          <>
            <div className="flex items-center gap-4 text-primary">
              <CheckCircle2 className="w-6 h-6" />
              <div>
                <div className="font-serif text-2xl">{state.signature}</div>
                <div className="text-xs text-muted-foreground mt-1">Signed {new Date(state.signed_at).toLocaleDateString()}</div>
              </div>
            </div>
            <div className="mt-8">
              <Button asChild variant="outline" className="rounded-full" data-testid="covenant-download-pdf">
                <a href={`${BACKEND}/api/covenant/pdf?auth=${encodeURIComponent(localStorage.getItem("atc_token") || "")}`}
                   target="_blank" rel="noreferrer">
                  <Download className="w-4 h-4 mr-2" /> Download signed covenant (PDF)
                </a>
              </Button>
            </div>
          </>
        ) : (
          <>
            <label className="text-xs uppercase tracking-widest text-muted-foreground">Sign with your name</label>
            <input data-testid="covenant-signature" value={sig} onChange={(e) => setSig(e.target.value)}
              className="notebook-input w-full font-serif text-3xl italic mt-2" />
            <div className="mt-8 flex justify-end">
              <Button onClick={sign} data-testid="covenant-sign" size="lg" className="rounded-full px-10">
                Sign the covenant
              </Button>
            </div>
          </>
        )}
      </section>

      <div className="mt-16">
        <h2 className="font-serif text-2xl mb-4">Who is your Timothy?</h2>
        <p className="text-muted-foreground">
          The one who's watching you already. The one you'll invite into this same handbook next. Write their name in your journal — and then reach out.
        </p>
      </div>
    </div>
  );
}
